import React, {useState, useRef, useEffect} from 'react';
import classNames from 'classnames';
import {
    Flex,
    PriorityIcon,
    Icon,
    Select,
    Dropdown,
    IconTrigger,
    Text
} from '@priority-software/priority-style-react';
import {withTooltip} from '../../../../components/Common/HOC/Custom/withTooltip';
import {withDropdownContext} from '@priority-software/priority-style-react';
import styles from '../../style/Submenu.module.scss';
import {menuWidth} from './constants';

export const Item = ({title, isSelected}) => {
    return (
        <Flex>
            <div>{title}</div>
            {isSelected && isSelected(title) && (
                <Icon icon={PriorityIcon.check} iconColor={'primary-500'} />
            )}
        </Flex>
    );
};

const _InnerSelect = props => {
    useEffect(() => {
        const {open, dropdownRef} = props.dropdownContext;
        if (open && dropdownRef.current && !dropdownRef.current.isFocused) {
            dropdownRef.current.focus();
        }
    }, []);

    const onClick = item => {
        const {closeDropdown} = props.dropdownContext;
        props.onChoose(item);
        closeDropdown();
        props.closeParent();
    };

    return (
        <div onClick={e => e.stopPropagation()} style={props.style}>
            <Select
                horizontalMenuPosition="right"
                options={props.options}
                hideSelectControl
                menuIsOpen
                onChange={onClick}
                closeMenuOnSelect
                isOptionSelected={(item: any) => {
                    return item.isSelected && item.isSelected(item.title);
                }}
                renderItem={Item}
                menuWidth={props.menuWidth}
                menuScrollMaxHeight={props.height}
                componentClasses={styles.hideMenuShadow}
                shadow={false}
            />
        </div>
    );
};

const InnerSelect = withDropdownContext(_InnerSelect);

const _Submenu = props => {
    const [submenuOpen, setSubmenuOpen] = useState(null);
    /*
    All the commented code in Submenu & in Submennu.module.scss
    is inetended to solve the proplem of a submenu
    displayed inside a scrollable menu (which is not the current state)
    */
    // const [submenuTop, setSubmenuTop] = useState(0);
    // const [submenuLeft, setSubmenuLeft] = useState(0);
    const [submenuHeight, setSubmenuHeight] = useState(0);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const {closeDropdown} = props.dropdownContext;

    useEffect(() => {
        onParentClick();
    }, [props.isSubmenuOpen]);

    const onParentClick = () => {
        if (submenuOpen !== null) {
            if (!submenuOpen) {
                const node = dropdownRef.current;
                const itemRect = node.getBoundingClientRect();
                const availableHeight = window.innerHeight - itemRect.bottom;
                setSubmenuHeight(availableHeight < 475 ? availableHeight - 25 : 450);
            }
            setSubmenuOpen(prevState => !prevState);
        } else {
            setSubmenuOpen(false);
        }
    };

    return (
        <div
            className={classNames('ignore-react-onclickoutside', styles.itemWrapper)}
            ref={dropdownRef}
        >
            <Text textColor="primary-700" skin="paragraph-1" componentClasses={styles.innerItem}>
                {props.title}
            </Text>

            <Dropdown
                openingSide="leftSide"
                open={submenuOpen}
                trigger={
                    <IconTrigger
                        className={`$/*{styles.submenuTriggerWrapper}*/ ${
                            submenuOpen ? styles.menuArrow : ''
                        }`}
                        icon={props.isRTL ? PriorityIcon.arrowLeft : PriorityIcon.arrowRight}
                    />
                }
            >
                <Dropdown.Content>
                    <InnerSelect
                        options={props.options}
                        onChoose={props.onChoose}
                        closeParent={closeDropdown}
                        height={submenuHeight}
                        menuWidth={menuWidth}
                    />
                </Dropdown.Content>
            </Dropdown>
        </div>
    );
};

const SubmenuComp = withTooltip(withDropdownContext(_Submenu));

const Submenu = props => <SubmenuComp {...props} wrapperClassname={styles.tooltipWrapper} />;

export default Submenu;
